import styles from './paymentSummary.module.scss';
import PriceSummary from './PriceSummary';
import { Medlemskapstype } from '../api/medlemskapAPI';
import { MedlemskapTypeId } from '../MedlemskapType/MedlemskapTypeId';

interface PaymentSummaryProps {
    medlemskapstype?: Medlemskapstype;
    discountCode: string;
    discount: number;
    hideDescription?: boolean;
}

function PaymentSummary({ medlemskapstype, discountCode, discount, hideDescription }: PaymentSummaryProps) {
    return (
        <>
            {medlemskapstype && (
                <div className={styles.paymentSummary}>
                    <h2 className={styles.name}>{medlemskapstype.name} </h2>
                    {!hideDescription && <p className={styles.description}>{medlemskapstype.description}</p>}
                    <PriceSummary
                        title={medlemskapstype.summaryTitle}
                        originalPrice={medlemskapstype.price}
                        discountCode={discountCode}
                        discount={discount}
                        showMembershipPeriodText={medlemskapstype.id !== MedlemskapTypeId.Livsvarig}
                    />
                </div>
            )}
        </>
    );
}

export default PaymentSummary;
